import { render, staticRenderFns } from "./fpzInvaccDetail.vue?vue&type=template&id=41c7801c"
import script from "./fpzInvaccDetail.vue?vue&type=script&lang=js"
export * from "./fpzInvaccDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports